import { TForm } from '@/components/forms/form-service-group/ServiceGroupForm.types';
import useDeleteServiceDivision from '@/hooks/queries/service-division-api/useDeleteServiceDivision';
import useGetServiceDivisionById from '@/hooks/queries/service-division-api/useGetServiceDivisionById';
import usePatchServiceDivision from '@/hooks/queries/service-division-api/usePatchServiceDivision';
import useGetServiceById from '@/hooks/queries/services-api/useGetServiceById';
import { getTimestampUTC, getTimeZone } from '@/utils/dates';
import { getChangedValues } from '@/utils/forms';
import { endOfDay, format, parse, startOfDay } from 'date-fns';
import { useParams } from 'react-router-dom';

const useEditServiceGroup = () => {
  const { id: serviceId, groupId: divisionId } = useParams();
  const {
    data: service,
    isError: isErrorService,
    isLoading: isLoadingService
  } = useGetServiceById(serviceId);
  const serviceDivision = service?.serviceDivisions.find(
    (division) => division.id === divisionId
  );
  const { mutate, isPending } = usePatchServiceDivision();
  const { mutate: deleteServiceDivision, isPending: isPendingDelete } =
    useDeleteServiceDivision();

  const { name, description, startTime, startHour, endTime, duration, id } =
    serviceDivision ?? {};
  const parsedTime = parse(startHour ?? '', 'HH:mm', new Date());
  const tz = service?.organization.tz ?? '';

  const isError = isErrorService;
  const isLoading = isLoadingService;

  const defaultValues = {
    name,
    description: description ?? undefined,
    startTime: startTime ? getTimeZone(startTime, tz) : undefined,
    startHour: parsedTime,
    endTime: endTime ? getTimeZone(endTime, tz) : undefined,
    duration
  };
  const onSubmit = (data: TForm) => {
    const startTime = getTimestampUTC({ date: startOfDay(data.startTime), tz });
    const endTime = getTimestampUTC({ date: endOfDay(data.endTime), tz });
    const onlyChangedData = getChangedValues<Partial<any>>(
      {
        ...defaultValues,
        startTime: defaultValues.startTime
          ? getTimeZone(defaultValues.startTime, tz)
          : undefined,
        endTime: defaultValues.endTime
          ? getTimeZone(defaultValues.endTime, tz)
          : undefined,
        startHour: format(defaultValues.startHour, 'HH:mm')
      },
      {
        ...data,
        startTime,
        endTime,
        startHour: format(data.startHour, 'HH:mm')
      }
    );

    mutate({
      payload: { ...onlyChangedData, service: service?.id },
      divisionId: serviceDivision?.id ?? ''
    });
  };

  return {
    serviceDivision,
    isError,
    isLoading,
    service,
    isPending,
    deleteServiceDivision,
    isPendingDelete,
    onSubmit,
    name,
    description,
    duration,
    id,
    defaultValues
  };
};

export default useEditServiceGroup;
